'use client';

import Link from 'next/link';
import { usePathname } from 'next/navigation';

import type { MenuItem } from '@/fo/ui/app/menu/base';

import { normalizeMenuPath } from '../utils/normalizeMenuPath';

import { styles } from './UiCategoryMenuPredator.styles';

export interface UiCategoryMenuPredatorProps {
  /** Пункты меню (используется только первый уровень, без вложенности) */
  items: MenuItem[];
  className?: string;
  ariaLabel?: string;
}

export const UiCategoryMenuPredator = ({
  items,
  className,
  ariaLabel = 'Predator'
}: UiCategoryMenuPredatorProps) => {
  const pathname = usePathname();
  const linkedItems = items.filter((item) => item.href.trim().length > 0);

  if (!linkedItems.length) {
    return null;
  }

  const currentPath = normalizeMenuPath(pathname);

  const isActiveLink = (href: string) => {
    const itemPath = normalizeMenuPath(href);

    return itemPath.length > 0 && itemPath === currentPath;
  };

  const slots = styles();

  return (
    <nav
      className={slots.base({ className })}
      aria-label={ariaLabel}
    >
      <ul className={slots.list()}>
        {linkedItems.map((item, index) => {
          const isActive = isActiveLink(item.href);

          return (
            <li
              key={`${item.href}-${index}`}
              className={slots.listItem()}
            >
              <Link
                href={item.href}
                className={slots.link({ active: isActive })}
                aria-current={isActive ? 'page' : undefined}
              >
                {item.image ? (
                  <>
                    {/* eslint-disable-next-line @next/next/no-img-element */}
                    <img
                      alt={item.image_alt_text?.trim() || item.label}
                      className={slots.image({ active: isActive })}
                      src={item.image}
                    />
                  </>
                ) : null}
                <span className={slots.linkText()}>{item.label}</span>
              </Link>
            </li>
          );
        })}
      </ul>
    </nav>
  );
};
